import { preferencesData } from './data';
import type { Preferences } from './types';

export function convertUrnToPreferences(urns: string[]): Preferences {
  const preferences: Preferences = {};

  urns.forEach((urn): void => {
    const preferenceData = preferencesData.options.find((option) => {
      return urn.startsWith(option.urnPrefix);
    });

    if (!preferenceData) {
      return;
    }

    const preferenceValue = Object.keys(preferenceData.urns).find((key) =>
      urn.endsWith(preferenceData.urns[key])
    );

    preferences[preferenceData.preference] = preferenceValue;
  });

  return preferences;
}
